import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/medallion-homes/node_modules/@mui/icons-material/esm/Email.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/medallion-homes/node_modules/@mui/icons-material/esm/ExpandMore.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/medallion-homes/node_modules/@mui/icons-material/esm/Facebook.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/medallion-homes/node_modules/@mui/icons-material/esm/Instagram.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/medallion-homes/node_modules/@mui/icons-material/esm/YouTube.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/medallion-homes/node_modules/@mui/material/Accordion/Accordion.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/medallion-homes/node_modules/@mui/material/AccordionDetails/AccordionDetails.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/medallion-homes/node_modules/@mui/material/AccordionSummary/AccordionSummary.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/medallion-homes/node_modules/@mui/material/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/medallion-homes/node_modules/@mui/material/Container/Container.js");
;
import(/* webpackMode: "eager" */ "/root/medallion-homes/node_modules/@mui/material/Grid2/Grid2.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/medallion-homes/node_modules/@mui/material/IconButton/IconButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/medallion-homes/node_modules/@mui/material/List/List.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/medallion-homes/node_modules/@mui/material/ListItem/ListItem.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/medallion-homes/node_modules/@mui/material/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/medallion-homes/node_modules/@mui/material/Typography/Typography.js");
;
import(/* webpackMode: "eager" */ "/root/medallion-homes/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/root/medallion-homes/src/app/components/footer.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/medallion-homes/src/app/components/Navbar.tsx");
;
import(/* webpackMode: "eager" */ "/root/medallion-homes/src/app/globals.css");
